import React from 'react'
import Navbar from './navbar'

const Header = () => {
  return (
	<header id='header' className='fixed z-50 w-full bg-white ww-full text-center h-[75px] shadow-lg'>
	  
	  <Navbar />
	  
	</header>
  )
}

export default Header
